<template>
  <div class="home">
       <!-- Navigation -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" id="mainNav">
            <div class="container">
            <router-link :to="{name: 'Home', hash:'#page-top'}" class="navbar-brand js-scroll-trigger"><img src="@/assets/img/navbar-logo5.png" alt="" /></router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav ml-auto">
                      <li class="nav-item">
                          <router-link :to="{name: 'Home', hash:'#bar'}" class="nav-link js-scroll-trigger text-uppercase">unser lokal</router-link>
                      </li>
                      <li class="nav-item">
                          <router-link :to="{name: 'Home', hash:'#menus'}" class="nav-link js-scroll-trigger text-uppercase">Menus</router-link>
                      </li>
                      <li class="nav-item">
                          <router-link :to="{name: 'Home', hash:'#handl'}" class="nav-link js-scroll-trigger text-uppercase">Öffnungszeiten & Anfahrt</router-link>
                      </li>
                      <li class="nav-item">
                          <router-link :to="{name: 'Home', hash:'#contact'}" class="nav-link js-scroll-trigger text-uppercase">Kontakt</router-link>
                      </li>
                        <!-- <li class="nav-item">
                            <router-link to="/unsubscribe" class="nav-link js-scroll-trigger text-uppercase">Unsubscribe</router-link>
                        </li> -->
                    </ul>
                </div>
            </div>
        </nav>

        <!-- Top -->
        <Top></Top>

        <!-- Bar Grid -->
        <Bar></Bar>

        <!-- Menus -->
        <Menus></Menus>
    
        <!-- Hours and Location -->
        <HoursAndLocation></HoursAndLocation>

        <!-- Links -->
        <Links></Links>

        <!-- Contact -->
        <Contact></Contact>
  
        <!-- Footer-->
        <Down></Down>

        <!-- <pdf src="./tracemonkey.pdf"></pdf>
        <pdf src="./pdf/WinterKarte_Bar_Barriere_20.pdf"></pdf>
        <iframe src='./pdf/WinterKarte_Bar_Barriere_20.pdf' ></iframe> -->

  </div>
</template>

<script>
import Top from '@/components/top.vue'
import Bar from '@/components/bar.vue'
import Menus from '@/components/menus.vue'
import HoursAndLocation from '@/components/handl.vue'
import Links from '@/components/links.vue'
import Contact from '@/components/contact.vue'
import Down from '@/components/down.vue'
// import pdf from 'vue-pdf'

export default {
  name: 'App',
  components: {
    Top,
    Bar,
    Menus,
    HoursAndLocation,
    Links,
    Contact,
    Down
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.mascontainer {
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
  background: rgba(78, 78, 77, 0.39);
}

</style>











